import { NgClass } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocationService } from '../../../utilities/services/location.service';
import { CityData } from './interfaces/city.interface';
import { CityService } from './services/city.service';
import { ModalService } from './services/modal.service';

@Component({
  selector: 'app-shared-city-modal',
  imports: [FormsModule, NgClass],
  templateUrl: './city-modal.component.html',
  styleUrl: './city-modal.component.scss',
})
export class CityModalComponent {
  @Output() citySelected = new EventEmitter<string>();

  loading = true;
  error: string | null = null;
  cities: CityData[] = [];

  constructor(
    private cityService: CityService,
    private locationService: LocationService,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {
    this.loadCities();
  }

  selectCity(city: CityData): void {
    this.locationService.setLocation(city);
    this.citySelected.emit(city.city);
    if (this.locationService.hasLocation()) {
      this.modalService.toggleModal(false);
    }
  }

  closeModal(): void {
    if (this.locationService.hasLocation()) {
      this.modalService.toggleModal(false);
    }
  }

  private loadCities(): void {
    this.cityService.getCities().subscribe({
      next: (cities) => {
        this.cities = cities;
        this.loading = false;
      },
      error: (err) => {
        this.error =
          'Error al cargar las ciudades. Por favor intente nuevamente.';
        this.loading = false;
      },
    });
  }
}
